import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { RcStatusBadgeProps } from './types';


export default /*@__PURE__*/_defineComponent({
  __name: 'RcStatusBadge',
  props: {
    status: {}
  },
  setup(__props: any) {

const props = __props;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["rc-status-badge", {[props.status]: true}])
  }, [
    _renderSlot(_ctx.$slots, "default")
  ], 2))
}
}

})